import React from 'react';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
type CtaButtonProps = {
  label: string;
  id?: string;
  showSecure?: boolean;
  className?: string;
};
export function CtaButton({
  label,
  id,
  showSecure = true,
  className = ''
}: CtaButtonProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-31" data-mp="ckj3x8gm1thh">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold px-5 py-5 text-center font-display text-[17px] font-extrabold uppercase leading-tight tracking-tight text-navy shadow-[0_6px_0_#B98400] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-[#FFD04F] active:translate-y-[4px] active:shadow-[0_2px_0_#B98400] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:text-xl" data-id="element-32" data-mp="qkagd4rhb1td">
        <span className="text-balance" data-id="element-33" data-mp="15a9dr5b7m97s">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-34" data-mp="157n32wt0vdlc" />
      </a>
      {showSecure && <p className="mt-3 flex items-center gap-1.5 text-xs font-medium text-ink-soft" data-id="element-35" data-mp="39z183c7amjtz">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-36" data-mp="3ew9g4jyq97hi" />
          Secure checkout · Instant digital access
        </p>}
    </div>;
}